"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jepAssertNever = void 0;
const jepAssertNever = (value, message) => {
    throw new Error(`Undiscriminated union member from JepAssertNever. Message: ${message}. value: ${value}`);
};
exports.jepAssertNever = jepAssertNever;
//# sourceMappingURL=jepAssertNever.js.map